import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MainService } from 'src/app/services/main.service';
import { FundService } from '../../services/fund.service';
import 'bootstrap'; ``
import * as $ from 'jquery';
import 'dotdotdot-js'
import { mobileMaxScreen } from 'src/app/constants/constants';

@Component({
  selector: 'app-private-fund',
  templateUrl: './private-fund.component.html',
  styleUrls: ['./private-fund.component.scss']
})
export class PrivateFundComponent implements OnInit, AfterViewInit {

  language = JSON.parse(localStorage.getItem('language'))
  route: string;
  banner: any;
  doc_list: any;
  flag: any
  isMobile = false;

  constructor(private _mainService: MainService, private _fundInfoService: FundService) { }

  ngOnInit() {
    if (window.screen.width <= mobileMaxScreen) { // 768px portrait
      this.isMobile = true;
    }
    this.flag = localStorage.getItem("language_flag")
    this._mainService.getBannerPrivate().subscribe(response => {
      this.banner = response;
    })


    this._fundInfoService.getFundDocPrivate().subscribe(response => {
      this.doc_list = response
    })
  }

  ngAfterViewInit() {
    ($('.carousel') as any).carousel();
  }

}
